export default {
  text: '#ffffff',
  primary: '#f68922',
  secondary: '#202020',
  background: 'black',
  backgroundSecondary: 'grey',
  light: '#fdfdfd',
  dark: '#202020'
}
